import IAReputationHome from '../views/IAReputation/Home.vue'
import IAReputationReputation from '../views/IAReputation/Pages/Reputation.vue'
import IAReputationVisibility from '../views/IAReputation/Pages/Visibility.vue'
import IAReputationGaia from '../views/IAReputation/Pages/Gaia.vue'
import IAReputationTopics from '../views/IAReputation/Pages/Topics.vue'
import IAReputationSources from '../views/IAReputation/Pages/Sources.vue'
import IAReputationPrompts from '../views/IAReputation/Pages/Prompts.vue'

export default {
  path: '/ia-reputation',
  name: 'IAReputationHome',
  component: IAReputationHome,
  redirect: '/ia-reputation/reputation/:paramCOD?',
  meta: {Auth: true, isIAReputation: true},
  props: true,
  children: [
    {
      path: 'reputation/:paramCOD?',
      name: 'IAReputationReputation',
      component: IAReputationReputation,
      meta: {Auth: true, isIAReputation: true},
      props(route) {
        return route.query || {}
      }
    },
    {
      path: 'visibility/:paramCOD?',
      name: 'IAReputationVisibility',
      component: IAReputationVisibility,
      meta: {Auth: true, isIAReputation: true},
      props(route) {
        return route.query || {}
      }
    },
    {
      path: 'google-ai-alignment/:paramCOD?',
      name: 'IAReputationGoogleAIAlignment',
      component: IAReputationGaia,
      meta: {auth: true, ico: 'googleaialignment'},
      props(route) {
        return route.query || {}
      }
    },
    {
      path: 'topics/:paramCOD?',
      name: 'IAReputationTopics',
      component: IAReputationTopics,
      meta: {Auth: true, isIAReputation: true},
      props(route) {
        return route.query || {}
      }
    },
    {
      path: 'sources/:paramCOD?',
      name: 'IAReputationSources',
      component: IAReputationSources,
      meta: {Auth: true, isIAReputation: true},
      props(route) {
        return route.query || {}
      }
    },
    {
      path: 'prompts/:paramCOD?',
      name: 'IAReputationPrompts',
      component: IAReputationPrompts,
      meta: {Auth: true, isIAReputation: true},
      props(route) {
        return route.query || {}
      }
    }
  ]
}
